/** Blue highlight for active selection and inserted text */
export const kHighlightClassSelection = 'inline-edit-highlight'
/** Grey highlight for text with pending edits (loading/review) */
export const kHighlightClassPending = 'inline-edit-pending-highlight'
